import find from "lodash/find";
import { AdminCredentialsSection } from "PFApp/profiles/edit/sections/admin_credentials_section";
import { AvailabilitySectionWrapper } from "PFApp/profiles/edit/sections/availability_section";
import CalendarsSection from "PFApp/profiles/edit/sections/calendars_section";
import { ContactInformationSection } from "PFApp/profiles/edit/sections/contact_information_section";
import CredentialsSection from "PFApp/profiles/edit/sections/credentials_section";
import DeleteUserSection from "PFApp/profiles/edit/sections/delete_user_section";
import DetailsSection from "PFApp/profiles/edit/sections/details_section";
import { NotificationsSection } from "PFApp/profiles/edit/sections/notifications_section";
import { PositionsSection } from "PFApp/profiles/edit/sections/positions/positions_section";
import useIsAvailabilityPermitted from "PFApp/use_is_availability_permitted";
import i18n from "PFCore/i18n";
import { FeatureFlag } from "PFCore/types/feature_flag";
import { Profile } from "PFTypes";

import { NavSection } from "./profile_edit_sections.types";
import { LanguageSettingsSection } from "./sections/language_settings/language_settings_section";

export const profileEditSections = (onShowTerms?: () => void): NavSection[] => [
  {
    section: "credentials",
    text: i18n.t("profiles:edit.emailAndPassword"),
    qaId: "credentials",
    component: CredentialsSection,
    requireFeature: FeatureFlag.PasswordSignin
  },
  {
    section: "notifications",
    text: i18n.t("profiles:edit.notificationsTitle"),
    qaId: "notifications-settings",
    component: NotificationsSection
  },
  {
    section: "language_settings",
    text: i18n.t("profiles:edit.languageSettings"),
    qaId: "delete-user",
    component: LanguageSettingsSection
  },
  {
    section: "terms_and_conditions",
    text: i18n.t("profiles:edit.termsAndConditions"),
    qaId: "terms_and_conditions",
    onClick: () => onShowTerms?.()
  },
  {
    section: "privacy_policy",
    text: i18n.t("profiles:edit.privacyPolicy"),
    qaId: "privacy_policy",
    onClick: () => window.open("https://www.profinda.com/privacy-policy/", "_blank")
  },
  {
    section: "delete_user",
    text: i18n.t("profiles:edit.deleteAccount"),
    qaId: "delete-user",
    component: DeleteUserSection,
    danger: true,
    requireFeature: FeatureFlag.SelfInactivation
  }
];

export const adminProfileEditSections = (profile?: Profile): NavSection[] => {
  /* @ts-ignore */
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const isAvailabilityPermitted = useIsAvailabilityPermitted(profile);

  return [
    {
      section: "details",
      text: i18n.t("profiles:edit.basicInfoAndExpertise"),
      qaId: "basic-info",
      component: DetailsSection
    },
    {
      section: "availability",
      icon: "calendar",
      text: i18n.t("profiles:edit.availability"),
      qaId: "availability",
      component: AvailabilitySectionWrapper,
      isVisible: () => isAvailabilityPermitted
    },
    {
      section: "positions",
      text: i18n.t("profiles:edit.positions"),
      qaId: "positions",
      component: PositionsSection
    },
    {
      section: "contact_information",
      text: i18n.t("profiles:edit.contactInformation"),
      qaId: "contact-info",
      component: ContactInformationSection
    },
    {
      section: "admin_credentials",
      text: i18n.t("profiles:edit.emailAndPermissionGroup"),
      qaId: "admin_credentials",
      component: AdminCredentialsSection
    },
    {
      section: "calendars",
      text: i18n.t("profiles:edit.calendars"),
      qaId: "calendars",
      component: CalendarsSection
    }
  ];
};

export const getProfileSectionText = (section: string, admin = false): string => {
  const sections = admin ? adminProfileEditSections() : profileEditSections();
  const item = find(sections, { section });
  return item ? item.text : "";
};
